import { createSlice } from '@reduxjs/toolkit'

const reducerName = 'pagesData'

const INITIAL_STATE = {}

const pagesDataSlice = createSlice({
  name: reducerName,
  initialState: INITIAL_STATE,
  reducers: {
    loadPageData(state, action) {
      const { activeEntityName, section, data } = action.payload

      if (!state[activeEntityName]) {
        state[activeEntityName] = {}
      }

      if (!state[activeEntityName]?.[section]) {
        state[activeEntityName][section] = data
      } else if (typeof state[activeEntityName][section] === 'object') {
        if (Array.isArray(state[activeEntityName][section])) {
          state[activeEntityName][section] = [
            ...state[activeEntityName][section],
            ...data,
          ]
        } else {
          state[activeEntityName][section] = {
            ...state[activeEntityName][section],
            ...data,
          }
        }
      } else {
        state[activeEntityName][section] = data
      }
    },

    updatePageData(state, action) {
      const { activeEntityName, section, key, data, shouldExtend, isObject } =
        action.payload

      if (!shouldExtend || !isObject) {
        state[activeEntityName][section][key] = data
        return
      }

      state[activeEntityName][section][key] = isObject
        ? { ...state[activeEntityName][section][key], ...data }
        : data
    },

    //
    //
    //

    clearPageData(state, action) {
      const { activeEntityName, section } = action.payload

      if (state[activeEntityName]?.[section]) {
        state[activeEntityName][section] = null
      }
    },

    clearAllPagesData() {
      return INITIAL_STATE
    },
  },
})

const { loadPageData, updatePageData, clearPageData, clearAllPagesData } =
  pagesDataSlice.actions

export const pagesDataActions = {
  loadPageData,
  updatePageData,
  clearPageData,
  clearAllPagesData,
}

export const { reducer: pagesDataReducer } = pagesDataSlice
